<template>
  <div class="flex flex-wrap gap-[14px]">
    <div
      v-for="(day, i) in weekDays"
      :key="i"
      class="rounded-full flex items-center justify-center border border-blue text-blue text-[12px] leading-[20px] tracking-[0.25px] w-[36px] h-[36px] uppercase cursor-pointer"
      :class="{
        'bg-blue text-white': isDaySelected(day.id),
        'hover:bg-blue-40 hover:text-charcoal hover:border-0': !isDaySelected(
          day.id
        ),
        'pointer-events-none text-grey-mid bg-grey-separator border-0':
          inactives.includes(day.id),
      }"
      @click="handleChangeWeekDays(day.id)"
    >
      {{ day.name }}
    </div>
  </div>
</template>

<script setup>
import { computed, ref, watch } from 'vue';

const emit = defineEmits(['update:modelValue']);
const props = defineProps({
  modelValue: {
    type: Array,
    default: () => [],
  },
  inactives: {
    type: Array,
    default: () => [],
  },
});

watch(
  () => props.modelValue,
  (newVal) => {
    selectedWeekDays.value = newVal;
  }
);

const selectedWeekDays = ref(props.modelValue);

const weekDays = computed(() => {
  return [
    { id: 0, name: 'SUN', status: true },
    { id: 1, name: 'MON', status: true },
    { id: 2, name: 'TUE', status: true },
    { id: 3, name: 'WED', status: true },
    { id: 4, name: 'THU', status: true },
    { id: 5, name: 'FRI', status: true },
    { id: 6, name: 'SAT', status: true },
  ];
});

const isDaySelected = (id) => {
  return selectedWeekDays.value.find((i) => i == id);
};

const handleChangeWeekDays = (id) => {
  const index = selectedWeekDays.value.findIndex((i) => i == id);

  if (index !== -1) {
    selectedWeekDays.value.splice(index, 1);
  } else {
    selectedWeekDays.value.push(id);
  }

  emit('update:modelValue', selectedWeekDays);
};
</script>
